import React from "react";
import { message } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MainPage from "../../MainPage";
import {
  apiCallback,
  statusChangeApiCallback,
} from "../../../ApiHandlers/Common";
import ListDeviceConfig from "./ListDeviceConfig";
import DeviceConfigForm from "./DeviceConfigForm";
import { EntityStatus, NavMenuItems } from "../../../Constants/Constants";
import { convertDeviceConfigList } from "../../../Helpers/ConfigHelpers";
import { convertDeviceListToDropdown } from "../../../Helpers/DeviceHelpers";
import { convertDeviceModelListToDropdown } from "../../../Helpers/DeviceModelHelpers";

class DeviceConfig extends React.Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.configuration.icon()}
        <span>{NavMenuItems.configuration.device.label}</span>
      </>,
    ];
    this.state = {
      action: null,
      record: null,
      modelData: [],
      modelDataLoading: false,
      selectedModel: null,
      deviceData: [],
      deviceDataLoading: false,
      selectedDevice: null,
      deletingDevice: false,
      selectedDeviceId: null,
      deviceConfigData: [],
      deviceConfigDataLoading: false,
      deleteConfigLoading:false,
    };
  }

  componentDidMount() {
    this.updateModelList();
  }

  updateModelList = () => {
    const { history, deviceModelApi } = this.props;
    this.setState({ modelDataLoading: true });
    const errorCallback = (error) => {
      this.setState({ modelDataLoading: false });
      message.error("Error fetching Device Model list");
    };
    const successCallback = (data) => {
      const modelData = convertDeviceModelListToDropdown(data);
      console.log("updateData data", modelData);
      this.setState({ modelData, modelDataLoading: false });
    };
    try {
      deviceModelApi.getDeviceModels(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  deleteConfig = (record) => {
    const { history, configManagementApi } = this.props;
    const errorCallback = (error) => {
      this.setState({deleteConfigDataLoading:false})
      console.log("Error deleting config", error);
      message.error("Unable to delete");
    };
    const successCallback = (data) => {
      this.setState({deleteConfigDataLoading:false})
      message.success("Config Deleted Successfully");
      this.updateDeviceConfigList();
    };
    try {
      this.setState({deleteConfigDataLoading:true})
      const config = {
        config: record.config,
        clientid: this.state.selectedDeviceId,
      };
      configManagementApi.removeDeviceConfig(
        config,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  updateDeviceList = (id) => {
    const modelId = id || this.state.selectedModel;
    if (!modelId) return;
    const { history, deviceApi } = this.props;
    this.setState({ deviceDataLoading: true });
    const errorCallback = (error) => {
      this.setState({ deviceDataLoading: false });
      message.error("Error fetching Device list");
    };
    const successCallback = (data) => {
      const deviceData = convertDeviceListToDropdown(data);
      console.log("updateData data", deviceData);
      this.setState({ deviceData, deviceDataLoading: false });
    };
    try {
      deviceApi.getDeviceByModelId(
        modelId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  updateDeviceConfigList = (id) => {
    const modelId = this.state.selectedModel;
    const deviceId = id || this.state.selectedDevice;
    if (!modelId || !deviceId) return;
    const { history, configManagementApi } = this.props;
    this.setState({ deviceConfigDataLoading: true });
    const errorCallback = (error) => {
      this.setState({ deviceConfigDataLoading: false });
      message.error("Error fetching Device Config list");
    };
    const successCallback = (data) => {
      const deviceConfigData = convertDeviceConfigList(data, modelId);
      console.log("updateData data", deviceConfigData);
      this.setState({ deviceConfigData, deviceConfigDataLoading: false });
    };
    try {
      configManagementApi.getConfigByDeviceUUId(
        deviceId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  onModelSelect = (id) => {
    this.setState({
      selectedModel: id,
      selectedDevice: null,
      deviceConfigData: [],
    });
    id && this.updateDeviceList(id);
  };

  onDeviceSelect = (device) => {
    this.setState({
      selectedDevice: device.value,
      selectedDeviceId: device.label,
    });
    device.value && this.updateDeviceConfigList(device.value);
  };

  onActionClick = (action, record) => () => {
    this.setState({ action, record });
  };

  onSubmit = ({ update = true, redirect = true } = {}) => {
    update && this.updateDeviceConfigList();
    redirect && this.setState({ action: null, record: null });
  };

  onStatusChange = (record, status) => {
    try {
      console.log("onStatusChange", status, record);
      const callback = statusChangeApiCallback({
        props: this.props,
        recordName: record.name,
        errorRollback: () => this.changeStatus(record, !status),
      });
      this.props.configManagementApi.statusUpdateDeviceConfig(
        record.providerId,
        record.serviceId,
        record.deviceModelId,
        record.groupId,
        record.deviceUuid,
        { status: status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE },
        callback
      );
      this.changeStatus(record, status);
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  changeStatus = (record, status) => {
    try {
      const { configId } = record;
      const deviceConfigData = [...this.state.deviceConfigData];
      deviceConfigData.forEach((item) => {
        if (item.configId === configId) {
          item.status = status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE;
        }
      });
      this.setState({ deviceConfigData });
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  render() {
    const {
      action,
      record,
      modelData,
      modelDataLoading,
      selectedModel,
      deviceData,
      deviceDataLoading,
      deleteConfigLoading,
      selectedDevice,
      deviceConfigData,
      selectedDeviceId,
      deviceConfigDataLoading,
    } = this.state;
    return (
      <MainPage>
        <div className="device-config-container">
          {!action ? (
            <ListDeviceConfig
              modelData={modelData}
              modelDataLoading={modelDataLoading}
              selectedModel={selectedModel}
              deviceData={deviceData}
              deviceDataLoading={deviceDataLoading}
              selectedDevice={selectedDevice}
              deviceConfigData={deviceConfigData}
              deviceConfigDataLoading={deviceConfigDataLoading}
              deleteConfigLoading={deleteConfigLoading}
              onModelSelect={this.onModelSelect}
              onDeviceSelect={this.onDeviceSelect}
              onActionClick={this.onActionClick}
              onStatusChange={this.onStatusChange}
              selectedDeviceId={selectedDeviceId}
              onConfigDelete={this.deleteConfig}
              parentBread={this.header}
            />
          ) : (
            <DeviceConfigForm
              action={action}
              record={record}
              onSubmit={this.onSubmit}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          )}
        </div>
      </MainPage>
    );
  }
}

DeviceConfig.propTypes = {
  deviceApi: PropTypes.object,
  deviceModelApi: PropTypes.object,
  configManagementApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  deviceApi: state.apis.deviceApi,
  deviceModelApi: state.apis.deviceModelApi,
  configManagementApi: state.apis.configManagementApi,
});
const connectedDeviceConfig = connect(mapStateToProps)(DeviceConfig);
export default withRouter(connectedDeviceConfig);
